<div class="" style="height: 100%">
    <router-outlet></router-outlet>
</div>

<ng-template ngbModalContainer></ng-template>
